import { createAction } from '@reduxjs/toolkit';
import { REQUEST_CHECK_OBJECT, REQUEST_CHECK_OBJECT_SUCCESS, REQUEST_CHECK_OBJECT_FAILURE } from './types';
import { AwsParamVO } from 'commons/vo/param/AwsParamVO';

export const requestCheckObject = createAction<{ param: AwsParamVO}, typeof REQUEST_CHECK_OBJECT>(
  REQUEST_CHECK_OBJECT
);
export const requestCheckObjectSuccess = createAction<{ exist: boolean }, typeof REQUEST_CHECK_OBJECT_SUCCESS>(REQUEST_CHECK_OBJECT_SUCCESS);
export const requestCheckObjectFailure = createAction(REQUEST_CHECK_OBJECT_FAILURE);
